export class InterfaceSageDTO {

    public societyList: number[];
    public startDate: Date;
    public endDate: Date;
    public periode: string;
}
